import React from 'react';
import { motion } from "motion/react";
import "../style/Location.css";

const ADDRESS = "Plot No.37, Valinath Society, U-M Road, Bhatar, Surat 395001, Gujarat, India";
const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${ADDRESS} (Bonzer Kitchen)`)}`;

const PinIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

const ArrowIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 17 17 7M7 7h10v10" />
    </svg>
);

const Location = () => {
    return (
        <section className="locationBox" id="location">
            <div className="locationHeader">
                <span className="locationEyebrow">Find us</span>
                <h2 className="locationTitle">
                    <span className="locationTitleLight">Our</span>
                    <span className="locationTitleBold">Location</span>
                </h2>
            </div>

            <motion.div
                className="locationCard"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="locationInfo">
                    <span className="locationInfoEyebrow">Head office</span>
                    <div className="locationAddressRow">
                        <span className="locationIcon"><PinIcon /></span>
                        <p className="locationAddress">{ADDRESS}</p>
                    </div>
                    <a
                        className="locationDirectionsBtn"
                        href={DIRECTIONS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Get directions
                        <ArrowIcon />
                    </a>
                </div>

                <div className="mapFrame">
                    <iframe
                        title="Bonzer Kitchen location"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        scrolling="no"
                        loading="lazy"
                        src="https://maps.google.com/maps?width=100%25&height=800&hl=en&q=Ploat%20No.37,%20Valinath%20Society,%20U-M%20Road,Bhatar,%20Surat%20395001,Gujarat,India+(Bonzer%20Kitchen)&t=k&z=16&ie=UTF8&iwloc=B&output=embed"
                    >
                        <a href={DIRECTIONS_URL}>View our location on Google Maps</a>
                    </iframe>
                </div>
            </motion.div>
        </section>
    );
};

export default Location;